import { useParams } from "react-router-dom";
import Hero from "@/components/Hero";
import { useCourses } from "../coursesAndOffers/hooks/useCourses";
import LecturesList from "./components/LecturesList";

function LecturesPage() {
    const { courseid, grade } = useParams();

    const filter = { field: "id", value: courseid };

    const { isPending, courses } = useCourses({ filter });

    const courseName = courses?.data[0].attributes.name;

    let year;
    if (grade === "1") {
        year = "الصف الأول الثانوي";
    }
    if (grade === "2") {
        year = "الصف الثاني الثانوي";
    }
    if (grade === "3") {
        year = "الصف الثالث الثانوي";
    }

    return (
        <>
            <Hero
                title="مادة اللغه العربية"
                isLoading={isPending}
                description={courseName?.split(" ").splice(0, 10).join(" ")}
                pagesLinks={[
                    {
                        name: courseName?.split(" ").splice(0, 5).join(" "),
                        link: `/${grade}/courses/${courseid}`,
                    },
                    { name: "الصفحة الرئيسية", link: `/` },
                    { name: year, link: `/${grade}/courses/` },
                    { name: "الفصول الدراسية", link: `/${grade}/courses/` },
                ]}
            />
            <div className="container py-5 mx-auto md:px-16 ">
                <h2 className="self-start text-2xl md:text-4xl pt-14 text-secondary-color">
                    احدث{" "}
                    <span className="text-secondary-color">المحاضرات </span>
                </h2>
                <LecturesList />
            </div>
        </>
    );
}

export default LecturesPage;
